
import {
  LeadType,
  Operation,
  OperationChild,
  PermissionCode,
  User,
} from '@/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

moment.locale('it');

@Component
export default class OperationComponentMixin extends Vue {
  @Prop(Object) readonly operation!: Operation;
  @Prop(Number) readonly childId!: number;

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get users(): User[] { return this.$store.getters.users; }

  get operationChild(): OperationChild | null {
    return this.operation.children
      && this.childId in this.operation.children
      && this.operation.children[this.childId]
      ? this.operation.children[this.childId] : null;
  }

  get childProjectType(): LeadType | null {
    if (!this.operationChild) return null;
    return this.operationChild.type;
  }

  get isCurrentUserOwnerOrRequester(): boolean {
    if (!this.operationChild || !this.user) {
      return false;
    }

    // Verifica se l'utente è tra gli utenti autorizzati (formato ':1:3:23:')
    const isAllowedUser = this.operationChild.allowedUsers
      && this.operationChild.allowedUsers.split(':').includes(this.user.id.toString());

    // Verifica se l'utente è tra gli owners
    const isOwner = this.operationChild.owners
      && this.operationChild.owners.some((owner) => owner.id === this.user.id);

    // Verifica se l'utente è il requester
    const isRequester = this.operationChild.requester
      && this.operationChild.requester.id === this.user.id;

    // Restituisce true se l'utente è owner o requester o super user
    return isAllowedUser || isOwner || isRequester || this.user.isSuperUser;
  }

  mDate(date: Date | null | undefined): string | null { return date ? moment(date).format('L') : null; }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }
}
